/**
 * Map ISO 4217 currency → ISO 3166-1 alpha-2 for flag emoji (representative jurisdiction).
 * Ambiguous cases (EUR, XOF, …) use a conventional choice.
 */
const CURRENCY_TO_REGION: Record<string, string> = {
  AED: "AE",
  ANG: "CW",
  ARS: "AR",
  AUD: "AU",
  AWG: "AW",
  BHD: "BH",
  BRL: "BR",
  BSD: "BS",
  BOB: "BO",
  BWP: "BW",
  BZD: "BZ",
  CAD: "CA",
  CHF: "CH",
  CLP: "CL",
  CNY: "CN",
  COP: "CO",
  CRC: "CR",
  CZK: "CZ",
  DKK: "DK",
  DOP: "DO",
  EGP: "EG",
  EUR: "EU",
  FJD: "FJ",
  GBP: "GB",
  GEL: "GE",
  GHS: "GH",
  GTQ: "GT",
  HKD: "HK",
  HNL: "HN",
  HRK: "HR",
  HUF: "HU",
  IDR: "ID",
  ILS: "IL",
  INR: "IN",
  ISK: "IS",
  JPY: "JP",
  KES: "KE",
  KHR: "KH",
  KRW: "KR",
  KWD: "KW",
  KYD: "KY",
  KZT: "KZ",
  LBP: "LB",
  MAD: "MA",
  MGA: "MG",
  MXN: "MX",
  MYR: "MY",
  MUR: "MU",
  NAD: "NA",
  NGN: "NG",
  NOK: "NO",
  NZD: "NZ",
  PAB: "PA",
  PEN: "PE",
  PHP: "PH",
  PLN: "PL",
  PYG: "PY",
  QAR: "QA",
  RON: "RO",
  RUB: "RU",
  SAR: "SA",
  SCR: "SC",
  SEK: "SE",
  SGD: "SG",
  THB: "TH",
  TOP: "TO",
  TRY: "TR",
  TTD: "TT",
  TWD: "TW",
  UAH: "UA",
  USD: "US",
  UYU: "UY",
  VND: "VN",
  VUV: "VU",
  WST: "WS",
  XCD: "AG",
  XOF: "SN",
  XPF: "PF",
  ZAR: "ZA",
  ZMW: "ZM",
  CDF: "CD",
  MVR: "MV",
  NPR: "NP",
  PKR: "PK",
  LKR: "LK",
  BDT: "BD",
  OMR: "OM",
  JOD: "JO",
  BGN: "BG",
  RSD: "RS",
  ALL: "AL",
  MKD: "MK",
  BAM: "BA",
  MZN: "MZ",
  AOA: "AO",
  UGX: "UG",
  TZS: "TZ",
  ETB: "ET",
  RWF: "RW",
  BIF: "BI",
  DJF: "DJ",
  ERN: "ER",
  SOS: "SO",
  SSP: "SS",
  LSL: "LS",
  SZL: "SZ",
  ZWL: "ZW",
  BMD: "BM",
  JMD: "JM",
  BBD: "BB",
  MGA: "MG",
  XAF: "CM",
  CVE: "CV",
  STN: "ST",
  GMD: "GM",
  GNF: "GN",
  LRD: "LR",
  SLL: "SL",
  SLE: "SL",
  MRU: "MR",
  KMF: "KM",
  MWK: "MW",
};

function regionToFlagEmoji(region: string): string {
  const upper = region.toUpperCase();
  if (upper.length !== 2 || !/^[A-Z]{2}$/.test(upper)) return "";
  const A = 0x1f1e6;
  const cp = [...upper].map((c) => A + (c.charCodeAt(0) - 0x41));
  try {
    return String.fromCodePoint(...cp);
  } catch {
    return "";
  }
}

/** Flag emoji for a currency code, or empty string if unmapped / invalid. */
export function getCurrencyFlagEmoji(currencyCode: string): string {
  const cc = currencyCode.trim().toUpperCase();
  const region = CURRENCY_TO_REGION[cc];
  if (!region) return "";
  return regionToFlagEmoji(region);
}
